import React from 'react';

import { useApplication } from '../AppContext';

const Test = () => {
	const app = useApplication();
	const [, forceUpdate] = React.useReducer(x => x + 1, 0);

	const handleShowNotification = React.useCallback(() => {
		app.showNotification?.({
			title: 'Test',
			type: 'Achievement',
			image: 'ace',
			points: 25,
			description: 'Test description',
		});
	}, [app]);

	const handleRemovedAds = React.useCallback(() => {
		app.userdata.removeAds = true;
		forceUpdate();
	}, [app]);

	const handleEnabledAds = React.useCallback(() => {
		app.userdata.removeAds = false;
		forceUpdate();
	}, [app]);
	const handleRemovedFullVersion = React.useCallback(() => {
		app.userdata.fullVersion = false;
		forceUpdate();
	}, [app]);
	const handleEnabledFullVersion = React.useCallback(() => {
		app.userdata.fullVersion = true;
		forceUpdate();
	}, [app]);

	const handleSound = React.useCallback(() => {
		app.setIsMuted(!app.userdata.isMuted);
	}, [app]);

	const handleResetData = React.useCallback(() => {
		app.resetData();
	}, [app]);

	return (
		<div id="Settings1" className="page paddingTop50">
			<div className="wrapper">
				<div className="pageTitle">
					<a className="ui-icon ui-back backButton" href="#"></a>
					<h1>Test</h1>
				</div>
				<div>
					<button onClick={() => {
						app.showAd(true);
					}}>
						Show Ad
					</button>
				</div>
				<div>
					<button onClick={() => {
						app.showEnjoyGame();
					}}>
						Show Enjoy Dialog
					</button>
				</div>
				<div>
					<button onClick={() => {
						app.showShare();
					}}>
						Show Share
					</button>
				</div>
				<div>  <button onClick={() => {
					app.showNotification('Test notification');
				}}>
					showNotification
				</button>
				</div>
				<div>
					<button onClick={handleShowNotification}>
						showNotification Achievement
					</button>
				</div>
				<div>
					<button onClick={() => {
						app.navigate('Game/Test/CrazyNinja');
					}}>
						Test GameUI Mode - Test vs Crazy Ninja
					</button>
				</div>
				<div>
					<button onClick={() => {
						fetch('assets/Decks/PixaromaDeck_SpriteSheet.png').then((response) => {
							console.log(response);
						}).catch((error) => {
							console.log(error);
						});
					}}>
						fetch("assets/Decks/PixaromaDeck_SpriteSheet.png")
					</button>
				</div>
				<div>
					<button onClick={handleSound}>
						Turn sound {app.userdata.isMuted ? 'On' : 'Off'}
					</button>
				</div>
				<div>
					<button onClick={handleRemovedAds}>
						Remove Ads
					</button>
				</div>
				<div>
					<button onClick={handleEnabledAds}>
						Enable Ads
					</button>
				</div>
				<div>
					<button onClick={handleRemovedFullVersion}>
						Remove FullVersion
					</button>
				</div>
				<div>
					<button onClick={handleEnabledFullVersion}>
						Enable FullVersion
					</button>
				</div>
				<div>
					<button onClick={handleResetData}>
						Reset Data
					</button>
				</div>
				<div>
					Full Version: {String(app.userdata.fullVersion)}
				</div>
				<div>
					RemoveAds: {String(app.userdata.removeAds)}
				</div>
				<div>
					coins: {app.userdata.coins}
				</div>
			</div>
		</div>
	);
};

export default Test;
